<template>
    <div
        class="pt-20 pb-10 px-2  sm:px-8 bg-contain"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondo_play_icons.png')}')`,
            backgroundColor: '#a000ff'
        }"
    >
        <h1
            class="font-primary text-center text-white text-3xl sm:text-3xl md:text-4xl lg:text-4xl leading-none mb-4 mt-6"
        >
            {{ firstChannel.title }}
        </h1>
        <div class="player container mx-auto mb-5">
            <LivePlayer
                class="w-75"
                v-if="firstChannel.id != '0'"
                :channel="firstChannel"
            ></LivePlayer>
        </div>

        <div class="container mx-auto" v-if="!$isMobile()">
            <div class="player  w-full max-w-screen-2xl mx-auto flex flex-wrap">
                <div
                    class="w-full sm:w-1/2 lg:w-1/4 px-4"
                    v-for="(live, ln) in firstChannel.programming"
                    v-bind:key="ln"
                >
                    <img
                        class="rounded"
                        :src="live.screenshot"
                        :alt="live.title"
                    />
                    <div
                        class="progress"
                        :style="{ width: live.progress + '%' }"
                    ></div>
                    <div class="w-full text-white text-xs">
                        <span>{{ dateformat(live.start) }}</span>
                        <span class="float-right">{{
                            dateformat(live.ends)
                        }}</span>
                    </div>
                    <span
                        class="text-white font-primary"
                        v-html="live.title"
                    ></span>
                </div>
            </div>
        </div>
        <div class="container mx-auto" v-else>
            <div
                class="player w-full max-w-screen-2xl mx-auto flex flex-wrap"
                v-if="firstChannel"
            >
                <div class="w-full sm:w-1/2 lg:w-1/4 pt-4 ">
                    <img
                        class="rounded"
                        :src="firstChannel.programming[0].screenshot"
                        :alt="firstChannel.programming[0].title"
                    />
                    <div
                        class="progress"
                        :style="{
                            width: firstChannel.programming[0].progress + '%'
                        }"
                    ></div>
                    <div class="w-full text-white text-xs">
                        <span>{{
                            dateformat(firstChannel.programming[0].start)
                        }}</span>
                        <span class="float-right">{{
                            dateformat(firstChannel.programming[0].ends)
                        }}</span>
                    </div>
                    <span
                        class="text-white font-primary"
                        v-html="firstChannel.programming[0].title"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import LivePlayer from "@/components/Live/Player";

export default {
    name: "LiveChannel",
    components: {
        LivePlayer
    },

    computed: {
        ...mapGetters(["registerOrHomeRoute", "getLiveChannels"]),

        firstChannel() {
            return this.getLiveChannels[0];
        },

        background() {
            if (!this.homeData) return "";

            return this.$isMobile()
                ? this.homeData.background_mobile
                : this.homeData.background;
        },

        slogan() {
            return this.homeData ? this.homeData.slogan : "";
        },

        slogan2() {
            return this.homeData ? this.homeData.slogan2 : "";
        }
    },
    methods: {
        dateformat: function(str) {
            return moment(str).format("HH:mm");
        }
    }
};
</script>

<style lang="scss" scoped>
.progress {
    height: 5px;
    background: red;
    width: 0%;
}
.buttons {
    display: block;
    text-align: center;
    height: 3em;
    width: 28em;
    max-width: 100%;
    margin: auto;
    .btn {
        width: 9em;
        padding: 0.5em;
        white-space: nowrap;
        text-align: center;
        display: block;
        float: left;
        margin: 0 1em;
    }
}
</style>
